import { db } from '@/firebase/init'
import { useUserStore } from '@/stores/userStore'
import { TurnaroundTime } from '@/globals/typescript/models/TurnaroundTime'
import type { TTurnaroundTime } from '@team-milva/lab-models/resources'
import { collection, onSnapshot, query, where } from 'firebase/firestore'
import { defineStore } from 'pinia'

export const useTurnaroundTimeStore = defineStore('turnaroundTime', {
  state: () => ({
    allTATs: [] as TurnaroundTime[],
    unsubscribeAllTATs: null as (() => void) | null,
  }),

  actions: {
    getTATs(): Promise<TurnaroundTime[]> {
      if (this.allTATsLoaded) {
        return Promise.resolve(this.allTATs)
      }

      const userStore = useUserStore()

      return new Promise((resolve) => {
        if (!userStore.currentUser) {
          return resolve([])
        }

        let resolved = false
        const q = query(
          collection(db, 'Apps', '-lab-management-', 'TATs'),
          where('accountID', '==', userStore.currentUser.labAccountID)
        )

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          const tats: TurnaroundTime[] = []
          querySnapshot.forEach((docSnap) => {
            tats.push(new TurnaroundTime(docSnap.data() as TTurnaroundTime))
          })
          this.allTATs = tats
          this.unsubscribeAllTATs = unsubscribe

          if (!resolved) {
            resolved = true
            resolve(tats)
          }
        })
      })
    },

    resetStore(): void {
      this.allTATs = []

      if (this.unsubscribeAllTATs) {
        this.unsubscribeAllTATs()
        this.unsubscribeAllTATs = null
      }
    },
  },

  getters: {
    allTATsLoaded: (state) => !!state.unsubscribeAllTATs,
  },
})
